// extracted by mini-css-extract-plugin
export default {"main":"layout_main__0C+vY","section":"layout_section__ccY4n","print":"layout_print__+2DS2"};